"use client"

import { useSearchParams } from "next/navigation"
import { useEffect } from "react"
import {
  getGachaTrackingFromSearchParams,
  hasGachaTrackingParams,
  storeGachaTracking,
} from "./gacha-tracking"

export function GachaTrackingCapture() {
  const searchParams = useSearchParams()

  useEffect(() => {
    if (!hasGachaTrackingParams(searchParams)) return
    storeGachaTracking(getGachaTrackingFromSearchParams(searchParams))
  }, [searchParams])

  return null
}
